"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentualDescontoValorPresente = void 0;
var percentualDescontoValorPresente = 0.09;
exports.percentualDescontoValorPresente = percentualDescontoValorPresente;
